export default __webpack_public_path__ + "static/media/icon-alert.2043b4de.svg";